export default __webpack_public_path__ + "static/ground-xs-54dbdfb7558ba96f2b0abc5920def182.png";